import { CollectionsApiClient } from '@fourthwall/services/dist/CollectionsApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateCollectionMutation = createMutationHook(
  CollectionsApiClient.updateCollection,
  {
    mutationKey: ['updateCollection'],
  },
)
